import React from 'react';  

export default function TableSkeleton({ cols }) {  
  return (  
    <table className="skeleton-table w-full border-collapse">  
      <thead className="skeleton-header">  
        <tr>  
          {cols.map((_, index) => (  
            <th key={index} className=" px-4 py-2">  
              <div className="" style={{ width: '100%' }}></div>  
            </th>  
          ))}  
        </tr>  
      </thead>  
      <tbody>  
        {Array.from({ length: 7 }).map((_, rowIndex) => (  
          <tr key={rowIndex} className="">  
            {cols.map((_, colIndex) => (  
              <td key={colIndex} className="skeleton-cell  px-4 py-2">  
                <div className="skeleton-box"></div>  
              </td>  
            ))}  
          </tr>  
        ))}  
      </tbody>  
    </table>  
  );  
}